import { useReducer } from 'react';
import type { PaymentData, PaymentAction } from '../context';

const INITIAL_DATA: PaymentData = {
  state: 'LOADING',
  paymentHash: '',
  assertionOptions: null,
  redirectUrlAfterPayment: null,
  errorMessage: '',
};

function paymentReducer(data: PaymentData, action: PaymentAction): PaymentData {
  switch (action.type) {
    case 'ASSERTION_OPTIONS_RECEIVED':
      return {
        ...data,
        state: 'AUTHENTICATING',
        assertionOptions: action.assertionOptions,
        redirectUrlAfterPayment: action.redirectUrlAfterPayment,
      };

    case 'START_AUTHENTICATING':
      return { ...data, state: 'AUTHENTICATING' };

    case 'START_SUBMITTING_AUTH':
      return { ...data, state: 'SUBMITTING_AUTH' };

    case 'AUTH_SUBMITTED':
      return { ...data, state: 'SUCCESS' };

    case 'SET_ERROR':
      return { ...data, state: 'ERROR', errorMessage: action.errorMessage };

    case 'RETRY':
      return { ...INITIAL_DATA, paymentHash: data.paymentHash };

    default:
      return data;
  }
}

interface InitArgs {
  readonly paymentHash: string;
}

function init(args: InitArgs): PaymentData {
  return {
    ...INITIAL_DATA,
    paymentHash: args.paymentHash,
  };
}

export function usePaymentState(
  paymentHash: string
): [PaymentData, (action: PaymentAction) => void] {
  return useReducer(paymentReducer, { paymentHash }, init);
}
